
module.config(function($stateProvider, $urlMatcherFactoryProvider) {

    var pattern = "/{type:participant|student}/{id:int}",
        student_url = $urlMatcherFactoryProvider.compile(pattern, {
            'params': {type: {value: 'student'}}});

    $stateProvider

    .state('student', {
        parent: 'basic',
        permission: 'viewStudents',
        abstract: true,
        url: student_url,
        resolve: {
            student: function($stateParams, ModelService) {
                return ModelService.getRelation('participant',
                    $stateParams.id, 'summary')
            },
            program: function(ModelService, student) {
                return ModelService.getRelation('program', student.program_id,
                                                'summary');
            },
            permissions: function(ModelService, student) {
                return ModelService.getRelation('program', student.program_id,
                                                'permissions');
            },
            issues: function($stateParams, IssueService) {
                return IssueService.loadIssues('participant', $stateParams.id);
            },
            auth: function($checkPermissions, permissions) {
                return $checkPermissions('viewStudents', permissions);
            },
        },
        views: {
            '': {
                templateUrl: 'students/overview/base',
                controller: 'StudentController',
            },
            'contextNav@basic': {
                templateUrl: 'students/menu',
                controller: function($scope, student, program, permissions) {
                    $scope.student = student;
                    $scope.program = program;
                    $scope.permissions = permissions;
                },
            },
            'entityId@basic': {
                template: '<small>pid</small><span>{{ ::pid }}</span><br>' +
                          '<small>sid</small><span>{{ ::sid }}</span>',
                controller: function($scope, student) {
                    $scope.sid = student.id;
                    $scope.pid = student.program_id;
                },

            }
        }
    })

    .state('student.overview', {
        url: "",
        templateUrl: 'students/overview/page',
        resolve: {
            overview: function(ModelService, student) {
                return ModelService.getModelRelation(student, 'overview');
            },
            tags: function(ModelService, student) {
                return ModelService.getModelRelation(student, 'tags');
            },
        },
        controllerAs: 'ctrl',
        controller: module.cC({
            inject: ['overview', 'ModelService', 'student', 'tags'],
            data: {
                'fJobs': 'overview.followup.jobs || []',
                'fEdus': 'overview.followup.edus || []',
                'fBasic': 'overview.followup.basic || []',
            },
            init: function() {
                this.fLength = this.fBasic.length + this.fJobs.length + this.fEdus.length;
            },
            methods: {
                searchTags: function(query, set) {
                    var params = {search: query, set: set};
                    return this.ModelService.getModelRelation(
                        this.student, 'tags/addable', params);
                },
            },
        }),
    });
});
